var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info-circle_svg__clip0_2055_13003)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.25a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM.9 9a8.1 8.1 0 1116.2 0A8.1 8.1 0 01.9 9zM9 4.5c.373 0 .675.303.675.675v1.35a.675.675 0 01-1.35 0v-1.35c0-.372.302-.675.675-.675zM9 9c.373 0 .675.303.675.675v3.15a.675.675 0 11-1.35 0v-3.15C8.325 9.303 8.627 9 9 9z",
    fill: "#272E35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info-circle_svg__clip0_2055_13003"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgInfoCircle;